import _map from 'lodash/map';
import { APPS } from 'commons-ui';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const APP_OPTIONS = _map(APPS, (app) => ({ id: app.appName, label: app.displayName }));

type EntityOption = {
	label: string;
	id: string;
};
export type AppDashboardAction = { [key: string]: Array<string> };

export type AppToDashboardActionMap = { [key: string]: AppDashboardAction };

export interface FormEntityActions {
	entity: string;
	actions: string[];
}

export interface RoleActions {
	appEntity?: AppEntityActions;
	settings?: EntityActions;
}

export interface EntityActions {
	[entity: string]: {
		[action: string]: boolean;
	};
}
export interface AppEntityActions {
	[app: string]: {
		dashboard?: EntityActions;
		gameAdmin?: EntityActions;
	};
}

export interface IRolesFormData {
	role: string;
	_id?: string;
	appEntity?: {
		app: string;
		dashboard: FormEntityActions[];
		gameAdmin: FormEntityActions[];
		appLevelAction?: string;
	}[];
	settings: FormEntityActions[];
}

export const APP_ACTIONS: { [key: string]: string } = {
	view: 'view',
	edit: 'edit',
	create: 'create',
	deploy: 'deploy',
	custom: 'custom'
};
export const DASHBOARD_ENTITY_OPTIONS: EntityOption[] = [
	{
		label: 'Home/Wallet Banners',
		id: 'banner'
	},
	{
		label: 'Lobby Banners',
		id: 'lobbyBanner'
	},
	{
		label: 'Home Page View',
		id: 'homepageView'
	},
	{
		label: 'Coupons',
		id: 'coupon'
	},
	{
		label: 'Tournaments',
		id: 'tournament'
	},
	// {
	// 	label: 'Referral Policy',
	// 	id: 'referralPolicy'
	// },
	{
		label: 'Partner Coupons',
		id: 'partnerCoupon'
	},
	{
		label: 'APK Update Info',
		id: 'apkUpdateInfo'
	},
	{
		label: 'AB Tests',
		id: 'abTest'
	},
	{
		label: 'Wallet',
		id: 'wallet'
	},
	{
		label: 'HomePage Layout',
		id: 'homePageLayout'
	},
	{
		label: 'Mtt Schema',
		id: 'mttSchema'
	},
	{
		label: 'Static Segments',
		id: 'staticSegments'
	},
	{
		label: 'Social',
		id: 'social'
	},
	{
		label: 'schedule Downtime',
		id: 'scheduledDowntime'
	},
	{
		label: 'Question Bank',
		id: 'questionBank'
	},
	{
		label: 'Notices',
		id: 'notices'
	},
	{
		label: 'User Segment',
		id: 'userSegment'
	},
	{
		label: 'Generic',
		id: 'generic'
	},
	{
		label: 'Downtime Refund',
		id: 'downtimeRefund'
	},
	{
		label: 'Finance',
		id: 'finance'
	},
	{
		label: 'Cashback Utilization',
		id: 'cashbackUtil'
	},
	{
		label: 'Utilities',
		id: 'utilities'
	},
	{
		label: 'Predict & Win Contest',
		id: 'predictAndWinV2'
	},
	{
		label: 'Referral',
		id: 'referral'
	},
	{
		label: 'Happy Hours',
		id: 'happyHour'
	},
	{
		label: 'Zupee Khelo Jeeto QnA',
		id: 'zupeeKheloJeeto'
	},
	{
		label: 'Magic Box',
		id: 'magicBox'
	},

	{
		label: 'Delink naman',
		id: 'delink'
	},
	{
		label: 'Outbound',
		id: 'outbound'
	},
	{
		label: 'Themes Zip Validation',
		id: 'themesZipValidation'
	},
	{
		label: 'Internal User',
		id: 'internalUser'
	}
	// {
	// 	label: 'Example',
	// 	id: 'example'
	// }
];
export const GAME_ADMIN_ENTITY_OPTIONS: EntityOption[] = [
	{
		label: 'Zookeeper',
		id: 'zookeeper'
	},
	{
		label: 'Revert Dashboard',
		id: 'zkRevertDashboard'
	},
	{
		label: 'Zookeeper PreProd',
		id: 'zkPreProd'
	},
	{
		label: 'Zookeeper Dashboard Update',
		id: 'zkDashBoardUpdate'
	}
];
export const SETTINGS_ENTITY_OPTIONS: EntityOption[] = [
	{
		label: 'User Management',
		id: 'user'
	},
	{
		label: 'Roles',
		id: 'role'
	}
];
export const PAGE_ENTITY_OPTIONS_MAP: { [key: string]: EntityOption[] } = {
	[PAGE_NAMES.dashboard]: DASHBOARD_ENTITY_OPTIONS,
	[PAGE_NAMES.settings]: SETTINGS_ENTITY_OPTIONS,
	[PAGE_NAMES.gameAdmin]: GAME_ADMIN_ENTITY_OPTIONS
};

const viewActions: AppDashboardAction = {
	[DASHBOARD_RESOURCES.finance]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDActiveOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getGSTConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getGSTActiveOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSActiveOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCtdPayoutSegmentsAndPriorityList
	],
	[DASHBOARD_RESOURCES.partnerCoupon]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getCoupons,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getPartnerCoupons
	],
	[DASHBOARD_RESOURCES.banner]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].getAllBanners,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].showVersionHistory
	],
	[DASHBOARD_RESOURCES.lobbyBanner]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].getAllBanners],
	[DASHBOARD_RESOURCES.coupon]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].getCoupons],
	[DASHBOARD_RESOURCES.tournament]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].getTournaments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].listTournamentObjects
	],
	[DASHBOARD_RESOURCES.apkUpdateInfo]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getApkVersions,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getAppUpdates,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdates
	],
	[DASHBOARD_RESOURCES.abTest]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperiments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getVersionHistory,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperimentVersions
	],
	// [DASHBOARD_RESOURCES.example]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.example].getAllExamples],
	[DASHBOARD_RESOURCES.wallet]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].getCsvDetails],
	[DASHBOARD_RESOURCES.homePageLayout]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].getVersionSupportedHomepageLayout,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].clearLayouts,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].showLayoutOrder
	],
	[DASHBOARD_RESOURCES.mttSchema]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].getMttSchema],
	[DASHBOARD_RESOURCES.staticSegments]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].listStaticSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].showVersionHistory,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].downloadCsv,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].downloadHistoricalCsv
	],
	[DASHBOARD_RESOURCES.social]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].getAllMemePosts,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].listContent
	],
	[DASHBOARD_RESOURCES.scheduledDowntime]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].listScheduledDowntime],
	[DASHBOARD_RESOURCES.notices]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].getNotices],
	[DASHBOARD_RESOURCES.userSegment]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getSegmentList,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].viewSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getUserDetails,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserRtfs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getBulkSegmentData
	],
	[DASHBOARD_RESOURCES.generic]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getPlatformFeatures,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getFeatureSegmentsList
	],
	[DASHBOARD_RESOURCES.cashbackUtil]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].getCashbackUtils],
	[DASHBOARD_RESOURCES.predictAndWinV2]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.predictAndWinV2].createContest,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.predictAndWinV2].updateContest
	],
	[DASHBOARD_RESOURCES.utilities]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].getAllAssets,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].viewAsset
	],
	[DASHBOARD_RESOURCES.referral]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.getReferralSegmentPolicies].getReferralSegmentPolicies],
	[DASHBOARD_RESOURCES.happyHour]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].getHappyHours],
	[DASHBOARD_RESOURCES.magicBox]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.magicBox].createSchedule,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.magicBox].createSchedule
	],
	[DASHBOARD_RESOURCES.delink]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.delink].userPhone],
	[DASHBOARD_RESOURCES.outbound]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.outbound].addCampaignData],
	[DASHBOARD_RESOURCES.themesZipValidation]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.themesZipValidation].addData],
	[DASHBOARD_RESOURCES.internalUser]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.internalUser].getInternalUserList]
};

const editActions: AppDashboardAction = {
	[DASHBOARD_RESOURCES.finance]: [
		...viewActions.finance,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateCTDConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateCTDOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].removeCTDOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateGSTConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateGSTOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].removeGSTOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].removeGSTConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateTDSConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateTDSOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].removeTDSOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].removeTDSConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updatePriorityList
	],
	[DASHBOARD_RESOURCES.partnerCoupon]: [
		...viewActions.partnerCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updateCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updatePartnerCoupons
	],
	[DASHBOARD_RESOURCES.banner]: [
		...viewActions.banner,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].updateBannerStatus,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].createUserSegment
	],
	[DASHBOARD_RESOURCES.lobbyBanner]: [
		...viewActions.lobbyBanner,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].updateBannerStatus
	],
	[DASHBOARD_RESOURCES.coupon]: [
		...viewActions.coupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].updateCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].addUsersToCoupon
	],
	[DASHBOARD_RESOURCES.tournament]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].createTournaments],
	[DASHBOARD_RESOURCES.apkUpdateInfo]: [
		...viewActions.apkUpdateInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateApkVersionInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateWebsiteUpdateInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateAppUpdateInfo
	],
	[DASHBOARD_RESOURCES.abTest]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].updateExperiment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].revertExperimentToVersion,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].fixUsersBucket,
		...viewActions.abTest
	],
	[DASHBOARD_RESOURCES.homePageLayout]: [
		...viewActions.homePageLayout,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].submitLayouts,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayoutOrder,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayouts
	],
	[DASHBOARD_RESOURCES.mttSchema]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].updateMttSchema, ...viewActions.mttSchema],
	[DASHBOARD_RESOURCES.staticSegments]: [
		...viewActions.staticSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].editSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].deleteSegment
	],
	[DASHBOARD_RESOURCES.social]: [
		...viewActions.social,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].updateMemePost,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].updateContent
	],
	[DASHBOARD_RESOURCES.scheduledDowntime]: [
		...viewActions.scheduledDowntime,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].updateScheduledDowntime
	],
	[DASHBOARD_RESOURCES.notices]: [...viewActions.notices, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].updateNotice],
	[DASHBOARD_RESOURCES.userSegment]: [
		...viewActions.userSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].deleteSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].scheduleSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].runSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].deleteScheduledCronJob,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserDetails,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserSegmentToVip,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].assignBulkSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].activateSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].forceDeleteSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].nonRapidRunSegment,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].nonRapidScheduleSegment
	],
	[DASHBOARD_RESOURCES.generic]: [
		...viewActions.generic,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.generic].updatePlatformFeature,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.generic].updateFeatureSegments
	],
	[DASHBOARD_RESOURCES.cashbackUtil]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].editCashbackSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].updatePriorityList,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].deleteCashbackSegments
	],
	[DASHBOARD_RESOURCES.predictAndWinV2]: [...viewActions.predictAndWinV2],
	[DASHBOARD_RESOURCES.utilities]: [...viewActions.utilities, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].addIndianAddress],
	[DASHBOARD_RESOURCES.referral]: [
		...viewActions.referral,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].updateUserReferralCode,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].updateUserReferralSegment
	],
	[DASHBOARD_RESOURCES.happyHour]: [...viewActions.happyHour, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].updateHappyHour],
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadQuestions,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadAnswers
	],
	[DASHBOARD_RESOURCES.magicBox]: [...viewActions.magicBox],
	[DASHBOARD_RESOURCES.delink]: [...viewActions.delink],
	[DASHBOARD_RESOURCES.outbound]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.outbound].addCampaignData],
	[DASHBOARD_RESOURCES.themesZipValidation]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.themesZipValidation].addData],
	[DASHBOARD_RESOURCES.internalUser]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.internalUser].createInternalUser]
};

const createActions: AppDashboardAction = {
	[DASHBOARD_RESOURCES.partnerCoupon]: [
		...editActions.partnerCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons
	],
	[DASHBOARD_RESOURCES.banner]: [...editActions.banner, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].addBanners],
	[DASHBOARD_RESOURCES.lobbyBanner]: [...editActions.lobbyBanner, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].addBanners],
	[DASHBOARD_RESOURCES.coupon]: [...editActions.coupon, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].createCoupon],
	[DASHBOARD_RESOURCES.tournament]: [
		...viewActions.tournament,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].rollbackTournamentFile,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].createTournament,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].getTournamentDiff,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].getTournamentCsvStatus,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].uploadTournamentCsv,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].approveTournamentCsv
	],
	[DASHBOARD_RESOURCES.apkUpdateInfo]: [
		...editActions.apkUpdateInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addApkVersionInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].createAppUpdateInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfo
	],
	[DASHBOARD_RESOURCES.abTest]: [...editActions.abTest, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].createAbTest],
	// [DASHBOARD_RESOURCES.example]: [...viewActions.example, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.example].createExample]
	[DASHBOARD_RESOURCES.wallet]: [...viewActions.wallet, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].addCsvDetails],
	[DASHBOARD_RESOURCES.homePageLayout]: [
		...editActions.homePageLayout,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createlayout,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createLayoutOrder
	],
	[DASHBOARD_RESOURCES.mttSchema]: [...editActions.mttSchema, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].createMttSchema],
	[DASHBOARD_RESOURCES.staticSegments]: [
		...editActions.staticSegments,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].createSegment
	],
	[DASHBOARD_RESOURCES.social]: [
		...editActions.social,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].createNewMemePost,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].getMemeUploadPreSignedUrl,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].createContent,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].getPreSignedUrl
	],
	[DASHBOARD_RESOURCES.scheduledDowntime]: [
		...editActions.scheduledDowntime,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].addScheduledDowntime
	],
	[DASHBOARD_RESOURCES.questionBank]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.questionBank].uploadCSV],
	[DASHBOARD_RESOURCES.notices]: [...editActions.notices, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.notices].createNotice],
	[DASHBOARD_RESOURCES.userSegment]: [...editActions.userSegment],
	[DASHBOARD_RESOURCES.generic]: [...editActions.generic],
	[DASHBOARD_RESOURCES.finance]: [
		...editActions.finance,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createCTDOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createGSTConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createGSTOffers,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSConfigs,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSOffers
	],
	[DASHBOARD_RESOURCES.cashbackUtil]: [DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil].addedCashbackSegments],
	[DASHBOARD_RESOURCES.predictAndWinV2]: [...editActions.predictAndWinV2],
	[DASHBOARD_RESOURCES.utilities]: [
		...editActions.utilities,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].createNewAsset,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].getMiscAssetUploadPreSignedUrl,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].addIndianAddress
	],
	[DASHBOARD_RESOURCES.happyHour]: [...editActions.happyHour, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].createHappyHour],
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadQuestions,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadAnswers
	],
	[DASHBOARD_RESOURCES.magicBox]: [...editActions.magicBox],
	[DASHBOARD_RESOURCES.outbound]: [...editActions.outbound],
	[DASHBOARD_RESOURCES.themesZipValidation]: [...editActions.themesZipValidation]
};

const deployActions: AppDashboardAction = {
	[DASHBOARD_RESOURCES.partnerCoupon]: [
		...createActions.partnerCoupon,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].deployCoupon
	],
	[DASHBOARD_RESOURCES.banner]: [...createActions.banner, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].deployBanner],
	[DASHBOARD_RESOURCES.lobbyBanner]: [
		...createActions.lobbyBanner,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].deployBanner,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.lobbyBanner].deleteBanner
	],
	[DASHBOARD_RESOURCES.coupon]: [...createActions.coupon, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].deployCoupon],
	// [DASHBOARD_RESOURCES.tournament]: [
	// 	...createActions.tournament,
	// 	DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].activateSpec,
	// 	DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].switchOnOffAddTournamentJobs
	// ],
	[DASHBOARD_RESOURCES.apkUpdateInfo]: [
		...createActions.apkUpdateInfo,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].deployWebsiteUpdate
	],
	[DASHBOARD_RESOURCES.abTest]: [...createActions.abTest],
	[DASHBOARD_RESOURCES.wallet]: [...createActions.wallet, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].addCoinsFromCsv],
	[DASHBOARD_RESOURCES.homePageLayout]: [...createActions.homePageLayout],
	[DASHBOARD_RESOURCES.wallet]: [...createActions.wallet, DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet].addCoinsFromCsv],
	[DASHBOARD_RESOURCES.zupeeKheloJeeto]: [
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadQuestions,
		DASHBOARD_SCOPES[DASHBOARD_RESOURCES.zupeeKheloJeeto].uploadAnswers
	]
};
export const APP_TO_DASHBOARD_ACTIONS_MAP: AppToDashboardActionMap = {
	[APP_ACTIONS.view]: viewActions,
	[APP_ACTIONS.edit]: editActions,
	[APP_ACTIONS.create]: createActions,
	[APP_ACTIONS.deploy]: deployActions
};

export const FORM_FIELD_KEYS = {
	APP: 'app',
	ROLE: 'role',
	APP_ENTITY_ACTION_CONFIG: 'appEntityActionConfig',
	APP_LEVEL_ACTION: 'appLevelAction',
	SETTINGS_CONFIG: 'settingsConfig',
	SETTINGS_ENTITY: 'settingsEntity',
	SETTINGS_ACTIONS: 'settingsActions',
	DASHBOARD_CONFIG: 'dashboardConfig',
	DASHBOARD_ENTITY: 'dashboardEntity',
	DASHBOARD_ACTIONS: 'dashboardActions',
	GAME_ADMIN_CONFIG: 'gameAdminConfig',
	GAME_ADMIN_ENTITY: 'gameAdminEntity',
	GAME_ADMIN_ACTIONS: 'gameAdminActions'
};

export const KEY_NAME_MAP = {
	APP: 'app',
	ROLE: 'role',
	APP_ENTITY_ACTION_CONFIG: 'appEntity',
	APP_LEVEL_ACTION: 'appLevelAction',
	SETTINGS_CONFIG: 'settings',
	SETTINGS_ENTITY: 'entity',
	SETTINGS_ACTIONS: 'actions',
	DASHBOARD_CONFIG: 'dashboard',
	DASHBOARD_ENTITY: 'entity',
	DASHBOARD_ACTIONS: 'actions',
	GAME_ADMIN_CONFIG: 'gameAdmin',
	GAME_ADMIN_ENTITY: 'entity',
	GAME_ADMIN_ACTIONS: 'actions'
};
